import "../../util/yup-locale";
import React from "react";
import { createRoot } from "react-dom/client";
import { UserArticle } from "../../features/user-article";
import * as Sentry from "@sentry/react";

const elements = document.getElementsByTagName("user-article");

if (elements.length > 0) {
  (async () => {
    for (let i = 0; i < elements.length; i++) {
      const element = elements.item(i) as HTMLElement;
      const root = createRoot(element);
      root.render(
        <Sentry.ErrorBoundary
          fallback={
            <p>
              Der opstod en kritisk fejl. Genindlæs siden og prøv igen, eller
              kontakt support for hjælp.
            </p>
          }
        >
          <UserArticle csrf={element.dataset.csrf!} />
        </Sentry.ErrorBoundary>
      );
    }
  })();
}
